"use strict";
// This list is based on the following sheet:
// https://docs.google.com/spreadsheets/d/1EWbvGuWHoI6v5xtldAIITqOkoMBytk8yu1Ajb76-BTQ/edit?usp=sharing
// The ID's were generated with moment-timezone .names() function
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMEZONES_WHITELIST = void 0;
exports.TIMEZONES_WHITELIST = [
    "Atlantic/Azores",
    "Atlantic/Cape_Verde",
    "Atlantic/South_Georgia",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/San_Juan",
    "America/Asuncion",
    "America/Cayenne",
    "America/Fortaleza",
    "America/Montevideo",
    "America/Santiago",
    "America/Sao_Paulo",
    "America/Caracas",
    "America/La_Paz",
    "America/Manaus",
    "America/Atikokan",
    "America/Bogota",
    "America/Indiana/Petersburg",
    "America/Lima",
    "America/Montreal",
    "America/New_York",
    "America/Toronto",
    "Chile/EasterIsland",
    "America/Chicago",
    "America/Costa_Rica",
    "America/El_Salvador",
    "America/Mexico_City",
    "America/Boise",
    "America/Chihuahua",
    "America/Denver",
    "America/Mazatlan",
    "America/Los_Angeles",
    "America/Vancouver",
    "America/Anchorage",
    "US/Alaska",
    "Pacific/Honolulu",
    "US/Aleutian",
    "US/Hawaii",
    "Pacific/Pago_Pago",
    "Africa/Monrovia",
    "Atlantic/Reykjavik",
    "Etc/UTC",
    "Europe/Dublin",
    "Europe/Lisbon",
    "Europe/London",
    "Europe/Amsterdam",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Budapest",
    "Europe/Copenhagen",
    "Europe/Ljubljana",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Paris",
    "Europe/Prague",
    "Europe/Rome",
    "Europe/Sarajevo",
    "Europe/Skopje",
    "Europe/Stockholm",
    "Europe/Vienna",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zurich",
    "Africa/Cairo",
    "Africa/Harare",
    "Africa/Tripoli",
    "Africa/Windhoek",
    "Asia/Amman",
    "Asia/Beirut",
    "Asia/Damascus",
    "Asia/Jerusalem",
    "Europe/Athens",
    "Europe/Bucharest",
    "Europe/Helsinki",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Nicosia",
    "Europe/Riga",
    "Europe/Sofia",
    "Europe/Tallinn",
    "Europe/Vilnius",
    "Africa/Nairobi",
    "Asia/Baghdad",
    "Asia/Bahrain",
    "Asia/Istanbul",
    "Asia/Riyadh",
    "Europe/Moscow",
    "Asia/Baku",
    "Asia/Dubai",
    "Asia/Tbilisi",
    "Europe/Volgograd",
    "Indian/Mauritius",
    "Asia/Kabul",
    "Asia/Ashgabat",
    "Asia/Karachi",
    "Asia/Tashkent",
    "Asia/Colombo",
    "Asia/Kolkata",
    "Asia/Katmandu",
    "Asia/Dhaka",
    "Asia/Urumqi",
    "Asia/Yangon",
    "Asia/Bangkok",
    "Asia/Ho_Chi_Minh",
    "Asia/Jakarta",
    "Asia/Krasnoyarsk",
    "Asia/Novokuznetsk",
    "Asia/Chongqing",
    "Asia/Hong_Kong",
    "Asia/Irkutsk",
    "Asia/Kuala_Lumpur",
    "Asia/Singapore",
    "Asia/Taipei",
    "Asia/Ulaanbaatar",
    "Australia/Perth",
    "Asia/Seoul",
    "Asia/Tokyo",
    "Asia/Yakutsk",
    "Australia/Darwin",
    "Asia/Vladivostok",
    "Australia/Brisbane",
    "Pacific/Guam",
    "Pacific/Port_Moresby",
    "Australia/Adelaide",
    "Asia/Magadan",
    "Australia/Hobart",
    "Australia/Melbourne",
    "Australia/Sydney",
    "Pacific/Fiji",
    "Pacific/Auckland",
    "Pacific/Fakaofo",
    "Pacific/Kiritimati"
];
//# sourceMappingURL=timezones-whitelist.js.map